import { render, staticRenderFns } from "./AllCustomerTable.vue?vue&type=template&id=5674d702"
import script from "./AllCustomerTable.vue?vue&type=script&lang=js"
export * from "./AllCustomerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports